/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthMainNavigationRouteImport } from './routes/_auth/_main-navigation'
import { Route as AuthAuthRedirectRouteImport } from './routes/_auth/auth-redirect'
import { Route as AuthMainNavigationIndexRouteImport } from './routes/_auth/_main-navigation/index'
import { Route as AuthAitoolsIndexRouteImport } from './routes/_auth/aitools/index'
import { Route as AuthCalendarIndexRouteImport } from './routes/_auth/calendar/index'
import { Route as AuthSetupSaleIdRouteImport } from './routes/_auth/setup/$saleId'
import { Route as AuthMainNavigationComptesIndexRouteImport } from './routes/_auth/_main-navigation/comptes/index'
import { Route as AuthMainNavigationDiscountIndexRouteImport } from './routes/_auth/_main-navigation/discount/index'
import { Route as AuthMainNavigationMarketingIndexRouteImport } from './routes/_auth/_main-navigation/marketing/index'
import { Route as AuthMainNavigationMarqueBrandIdRouteImport } from './routes/_auth/_main-navigation/marque/$brandId'
import { Route as AuthMainNavigationUnauthorizedIndexRouteImport } from './routes/_auth/_main-navigation/unauthorized/index'
import { Route as AuthMainNavigationVenteSaleIdRouteImport } from './routes/_auth/_main-navigation/vente/$saleId'
import { Route as AuthMainNavigationVentesIndexRouteImport } from './routes/_auth/_main-navigation/ventes/index'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMainNavigationRoute = AuthMainNavigationRouteImport.update({
  id: '/_main-navigation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthRedirectRoute = AuthAuthRedirectRouteImport.update({
  id: '/auth-redirect',
  path: '/auth-redirect',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMainNavigationIndexRoute = AuthMainNavigationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMainNavigationRoute,
} as any)
const AuthAitoolsIndexRoute = AuthAitoolsIndexRouteImport.update({
  id: '/aitools/',
  path: '/aitools/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCalendarIndexRoute = AuthCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetupSaleIdRoute = AuthSetupSaleIdRouteImport.update({
  id: '/setup/$saleId',
  path: '/setup/$saleId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMainNavigationComptesIndexRoute =
  AuthMainNavigationComptesIndexRouteImport.update({
    id: '/comptes/',
    path: '/comptes/',
    getParentRoute: () => AuthMainNavigationRoute,
  } as any)
const AuthMainNavigationDiscountIndexRoute =
  AuthMainNavigationDiscountIndexRouteImport.update({
    id: '/discount/',
    path: '/discount/',
    getParentRoute: () => AuthMainNavigationRoute,
  } as any)
const AuthMainNavigationMarketingIndexRoute =
  AuthMainNavigationMarketingIndexRouteImport.update({
    id: '/marketing/',
    path: '/marketing/',
    getParentRoute: () => AuthMainNavigationRoute,
  } as any)
const AuthMainNavigationMarqueBrandIdRoute =
  AuthMainNavigationMarqueBrandIdRouteImport.update({
    id: '/marque/$brandId',
    path: '/marque/$brandId',
    getParentRoute: () => AuthMainNavigationRoute,
  } as any)
const AuthMainNavigationUnauthorizedIndexRoute =
  AuthMainNavigationUnauthorizedIndexRouteImport.update({
    id: '/unauthorized/',
    path: '/unauthorized/',
    getParentRoute: () => AuthMainNavigationRoute,
  } as any)
const AuthMainNavigationVenteSaleIdRoute =
  AuthMainNavigationVenteSaleIdRouteImport.update({
    id: '/vente/$saleId',
    path: '/vente/$saleId',
    getParentRoute: () => AuthMainNavigationRoute,
  } as any)
const AuthMainNavigationVentesIndexRoute =
  AuthMainNavigationVentesIndexRouteImport.update({
    id: '/ventes/',
    path: '/ventes/',
    getParentRoute: () => AuthMainNavigationRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthMainNavigationIndexRoute
  '/auth-redirect': typeof AuthAuthRedirectRoute
  '/setup/$saleId': typeof AuthSetupSaleIdRoute
  '/aitools/': typeof AuthAitoolsIndexRoute
  '/calendar/': typeof AuthCalendarIndexRoute
  '/marque/$brandId': typeof AuthMainNavigationMarqueBrandIdRoute
  '/vente/$saleId': typeof AuthMainNavigationVenteSaleIdRoute
  '/comptes/': typeof AuthMainNavigationComptesIndexRoute
  '/discount/': typeof AuthMainNavigationDiscountIndexRoute
  '/marketing/': typeof AuthMainNavigationMarketingIndexRoute
  '/unauthorized/': typeof AuthMainNavigationUnauthorizedIndexRoute
  '/ventes/': typeof AuthMainNavigationVentesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthMainNavigationIndexRoute
  '/auth-redirect': typeof AuthAuthRedirectRoute
  '/setup/$saleId': typeof AuthSetupSaleIdRoute
  '/aitools': typeof AuthAitoolsIndexRoute
  '/calendar': typeof AuthCalendarIndexRoute
  '/marque/$brandId': typeof AuthMainNavigationMarqueBrandIdRoute
  '/vente/$saleId': typeof AuthMainNavigationVenteSaleIdRoute
  '/comptes': typeof AuthMainNavigationComptesIndexRoute
  '/discount': typeof AuthMainNavigationDiscountIndexRoute
  '/marketing': typeof AuthMainNavigationMarketingIndexRoute
  '/unauthorized': typeof AuthMainNavigationUnauthorizedIndexRoute
  '/ventes': typeof AuthMainNavigationVentesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/_main-navigation': typeof AuthMainNavigationRouteWithChildren
  '/_auth/auth-redirect': typeof AuthAuthRedirectRoute
  '/_auth/setup/$saleId': typeof AuthSetupSaleIdRoute
  '/_auth/_main-navigation/': typeof AuthMainNavigationIndexRoute
  '/_auth/aitools/': typeof AuthAitoolsIndexRoute
  '/_auth/calendar/': typeof AuthCalendarIndexRoute
  '/_auth/_main-navigation/marque/$brandId': typeof AuthMainNavigationMarqueBrandIdRoute
  '/_auth/_main-navigation/vente/$saleId': typeof AuthMainNavigationVenteSaleIdRoute
  '/_auth/_main-navigation/comptes/': typeof AuthMainNavigationComptesIndexRoute
  '/_auth/_main-navigation/discount/': typeof AuthMainNavigationDiscountIndexRoute
  '/_auth/_main-navigation/marketing/': typeof AuthMainNavigationMarketingIndexRoute
  '/_auth/_main-navigation/unauthorized/': typeof AuthMainNavigationUnauthorizedIndexRoute
  '/_auth/_main-navigation/ventes/': typeof AuthMainNavigationVentesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-redirect'
    | '/setup/$saleId'
    | '/aitools/'
    | '/calendar/'
    | '/marque/$brandId'
    | '/vente/$saleId'
    | '/comptes/'
    | '/discount/'
    | '/marketing/'
    | '/unauthorized/'
    | '/ventes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-redirect'
    | '/setup/$saleId'
    | '/aitools'
    | '/calendar'
    | '/marque/$brandId'
    | '/vente/$saleId'
    | '/comptes'
    | '/discount'
    | '/marketing'
    | '/unauthorized'
    | '/ventes'
  id:
    | '__root__'
    | '/_auth'
    | '/_auth/_main-navigation'
    | '/_auth/auth-redirect'
    | '/_auth/setup/$saleId'
    | '/_auth/_main-navigation/'
    | '/_auth/aitools/'
    | '/_auth/calendar/'
    | '/_auth/_main-navigation/marque/$brandId'
    | '/_auth/_main-navigation/vente/$saleId'
    | '/_auth/_main-navigation/comptes/'
    | '/_auth/_main-navigation/discount/'
    | '/_auth/_main-navigation/marketing/'
    | '/_auth/_main-navigation/unauthorized/'
    | '/_auth/_main-navigation/ventes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_main-navigation': {
      id: '/_auth/_main-navigation'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthMainNavigationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/auth-redirect': {
      id: '/_auth/auth-redirect'
      path: '/auth-redirect'
      fullPath: '/auth-redirect'
      preLoaderRoute: typeof AuthAuthRedirectRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_main-navigation/': {
      id: '/_auth/_main-navigation/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthMainNavigationIndexRouteImport
      parentRoute: typeof AuthMainNavigationRoute
    }
    '/_auth/aitools/': {
      id: '/_auth/aitools/'
      path: '/aitools'
      fullPath: '/aitools/'
      preLoaderRoute: typeof AuthAitoolsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/calendar/': {
      id: '/_auth/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AuthCalendarIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/setup/$saleId': {
      id: '/_auth/setup/$saleId'
      path: '/setup/$saleId'
      fullPath: '/setup/$saleId'
      preLoaderRoute: typeof AuthSetupSaleIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_main-navigation/comptes/': {
      id: '/_auth/_main-navigation/comptes/'
      path: '/comptes'
      fullPath: '/comptes/'
      preLoaderRoute: typeof AuthMainNavigationComptesIndexRouteImport
      parentRoute: typeof AuthMainNavigationRoute
    }
    '/_auth/_main-navigation/discount/': {
      id: '/_auth/_main-navigation/discount/'
      path: '/discount'
      fullPath: '/discount/'
      preLoaderRoute: typeof AuthMainNavigationDiscountIndexRouteImport
      parentRoute: typeof AuthMainNavigationRoute
    }
    '/_auth/_main-navigation/marketing/': {
      id: '/_auth/_main-navigation/marketing/'
      path: '/marketing'
      fullPath: '/marketing/'
      preLoaderRoute: typeof AuthMainNavigationMarketingIndexRouteImport
      parentRoute: typeof AuthMainNavigationRoute
    }
    '/_auth/_main-navigation/marque/$brandId': {
      id: '/_auth/_main-navigation/marque/$brandId'
      path: '/marque/$brandId'
      fullPath: '/marque/$brandId'
      preLoaderRoute: typeof AuthMainNavigationMarqueBrandIdRouteImport
      parentRoute: typeof AuthMainNavigationRoute
    }
    '/_auth/_main-navigation/unauthorized/': {
      id: '/_auth/_main-navigation/unauthorized/'
      path: '/unauthorized'
      fullPath: '/unauthorized/'
      preLoaderRoute: typeof AuthMainNavigationUnauthorizedIndexRouteImport
      parentRoute: typeof AuthMainNavigationRoute
    }
    '/_auth/_main-navigation/vente/$saleId': {
      id: '/_auth/_main-navigation/vente/$saleId'
      path: '/vente/$saleId'
      fullPath: '/vente/$saleId'
      preLoaderRoute: typeof AuthMainNavigationVenteSaleIdRouteImport
      parentRoute: typeof AuthMainNavigationRoute
    }
    '/_auth/_main-navigation/ventes/': {
      id: '/_auth/_main-navigation/ventes/'
      path: '/ventes'
      fullPath: '/ventes/'
      preLoaderRoute: typeof AuthMainNavigationVentesIndexRouteImport
      parentRoute: typeof AuthMainNavigationRoute
    }
  }
}

interface AuthMainNavigationRouteChildren {
  AuthMainNavigationIndexRoute: typeof AuthMainNavigationIndexRoute
  AuthMainNavigationMarqueBrandIdRoute: typeof AuthMainNavigationMarqueBrandIdRoute
  AuthMainNavigationVenteSaleIdRoute: typeof AuthMainNavigationVenteSaleIdRoute
  AuthMainNavigationComptesIndexRoute: typeof AuthMainNavigationComptesIndexRoute
  AuthMainNavigationDiscountIndexRoute: typeof AuthMainNavigationDiscountIndexRoute
  AuthMainNavigationMarketingIndexRoute: typeof AuthMainNavigationMarketingIndexRoute
  AuthMainNavigationUnauthorizedIndexRoute: typeof AuthMainNavigationUnauthorizedIndexRoute
  AuthMainNavigationVentesIndexRoute: typeof AuthMainNavigationVentesIndexRoute
}

const AuthMainNavigationRouteChildren: AuthMainNavigationRouteChildren = {
  AuthMainNavigationIndexRoute: AuthMainNavigationIndexRoute,
  AuthMainNavigationMarqueBrandIdRoute: AuthMainNavigationMarqueBrandIdRoute,
  AuthMainNavigationVenteSaleIdRoute: AuthMainNavigationVenteSaleIdRoute,
  AuthMainNavigationComptesIndexRoute: AuthMainNavigationComptesIndexRoute,
  AuthMainNavigationDiscountIndexRoute: AuthMainNavigationDiscountIndexRoute,
  AuthMainNavigationMarketingIndexRoute: AuthMainNavigationMarketingIndexRoute,
  AuthMainNavigationUnauthorizedIndexRoute:
    AuthMainNavigationUnauthorizedIndexRoute,
  AuthMainNavigationVentesIndexRoute: AuthMainNavigationVentesIndexRoute,
}

const AuthMainNavigationRouteWithChildren =
  AuthMainNavigationRoute._addFileChildren(AuthMainNavigationRouteChildren)

interface AuthRouteChildren {
  AuthMainNavigationRoute: typeof AuthMainNavigationRouteWithChildren
  AuthAuthRedirectRoute: typeof AuthAuthRedirectRoute
  AuthSetupSaleIdRoute: typeof AuthSetupSaleIdRoute
  AuthAitoolsIndexRoute: typeof AuthAitoolsIndexRoute
  AuthCalendarIndexRoute: typeof AuthCalendarIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthMainNavigationRoute: AuthMainNavigationRouteWithChildren,
  AuthAuthRedirectRoute: AuthAuthRedirectRoute,
  AuthSetupSaleIdRoute: AuthSetupSaleIdRoute,
  AuthAitoolsIndexRoute: AuthAitoolsIndexRoute,
  AuthCalendarIndexRoute: AuthCalendarIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
